import {
  OPEN_CONNECT,
  CLOSE_CONNECT,
  GET_SENT_MESSAGES,
  SEND_CONNECT,
  GET_INBOX_MESSAGES,
  RESET_ALL,
} from "../config/actionTypes";

const initialState = {
  isOpen: false,
  sendMessages: null,
  inbox: null,
  isUpdated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case OPEN_CONNECT:
      return { ...state, isOpen: true };

    case CLOSE_CONNECT:
      return { ...state, isOpen: false };

    case GET_SENT_MESSAGES:
      return { ...state, isUpdated: true, sendMessages: action.payload };

    case GET_INBOX_MESSAGES:
      return { ...state, isUpdated: true, inbox: action.payload };

    case SEND_CONNECT:
      return {
        ...state,
        isUpdated: false,
      };
    case RESET_ALL:
      return initialState;
    default:
      return state;
  }
}
